import axios from "axios";

import { 
    getCookie, 
    setCookie 
} from "../utils/cookieHandle";

export const RequestNextApi = axios.create({
    baseURL: `${process.env.HOST_URL}/api`
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

const getCleanReturnUrl = () => {
    const currentPath = window.location.pathname + window.location.search;
    
    // If we're already on login/signin, extract the original returnUrl
    if (window.location.pathname === '/login' || window.location.pathname === '/signin') {
        const urlParams = new URLSearchParams(window.location.search);
        const existingReturnUrl = urlParams.get('returnUrl');
        if (existingReturnUrl) {
            // Decode and return the original returnUrl
            const decodedUrl = decodeURIComponent(existingReturnUrl);
            // Make sure the decoded URL doesn't also contain login
            if (!decodedUrl.includes('/login')) {
                return decodedUrl;
            }
        }
        // If no valid returnUrl found or it contains login, default to members home
        return '/members/home';
    }
    
    // If not on login page, return current path
    return currentPath;
};

RequestNextApi.interceptors.response.use(
    response => {
        return response;
    },
    err => {
        const failedRequest = err.config;
        
        if (err.response.status === 401 && failedRequest.url.includes('login')) {
            return Promise.reject(err);
        }

        if (err.response.status === 401 && !failedRequest._retry) {
            if (isRefreshing) {
                return new Promise(function(resolve, reject) {
                    failedQueue.push({ resolve, reject });
                })
                    .then(token => {
                        let failedRequestData = JSON.parse(failedRequest.data);
                        let newData = {
                            ...failedRequestData,
                            jwtToken: token
                        };
                        failedRequest.data = newData;
                        return RequestNextApi(failedRequest);
                    })
                    .catch(err => {
                        return Promise.reject(err);
                    });
            }

            failedRequest._retry = true;
            isRefreshing = true;

            return new Promise(function(resolve, reject) {
                RequestNextApi.post(
                    '/login/refreshtoken', 
                    {
                        token: getCookie('jwt-refresh-token'),
                        remote_addr: getCookie('remote_addr')
                    })
                    .then((res) => {
                        setCookie('jwt-token', res.data.jwtToken);
                        setCookie('jwt-refresh-token', res.data.refreshToken, {expires: 3});
                        let failedRequestData = JSON.parse(failedRequest.data);
                        let newData = {
                            ...failedRequestData,
                            jwtToken: res.data.jwtToken
                        };
                        failedRequest.data = newData;
                        processQueue(null, res.data.jwtToken);
                        resolve(RequestNextApi(failedRequest));
                    })
                    .catch(err => {
                        const cleanReturnUrl = getCleanReturnUrl();
                        window.location.href = (`${process.env.HOST_URL}/login?returnUrl=${encodeURIComponent(cleanReturnUrl)}`);
                        processQueue(err, null);
                        reject(err);
                    })
                    .then(() => {
                        isRefreshing = false;
                    });
            });
        }

        return Promise.reject(err);
    }
);

export const KingdomApi = axios.create({
    baseURL: process.env.API_URL,
    headers: {
        'X-App-Authorization': `Application ${process.env.APP_TOKEN}`, 
        // 'Host': process.env.HOST_DOMAIN, 
        'Accept': 'application/json', 
        'Content-Type': 'application/json', 
    }
});
